var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBath = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91382 9.41069H14.6947C14.7363 9.41061 14.7775 9.41922 14.8157 9.43597C14.8539 9.45273 14.8884 9.47728 14.9169 9.50812C14.9455 9.53896 14.9675 9.57542 14.9817 9.61527C14.9959 9.65512 15.0019 9.69751 14.9995 9.73983C14.9171 11.1628 14.3043 12.4999 13.2865 13.4777C12.2686 14.4555 10.9226 15 9.52385 14.9999H6.47676C5.07746 15.0001 3.731 14.4553 2.71296 13.477C1.69493 12.4987 1.08233 11.1609 1.00055 9.73735C0.998053 9.69503 1.00409 9.65264 1.01828 9.61279C1.03247 9.57294 1.05452 9.53647 1.08307 9.50564C1.11161 9.4748 1.14605 9.45025 1.18427 9.43349C1.22248 9.41673 1.26366 9.40813 1.30526 9.4082H4.64791",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2109 1.87281L11.7594 1.31388C11.9352 1.15457 12.1525 1.05051 12.3851 1.01427C12.6177 0.978032 12.8555 1.01116 13.07 1.10965C13.2845 1.20814 13.4665 1.36779 13.5939 1.56932C13.7213 1.77086 13.7888 2.00567 13.7882 2.24542V9.41079",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2094 3.95527C11.3459 3.81915 11.4545 3.65681 11.529 3.47764C11.6035 3.29847 11.6424 3.10603 11.6434 2.91144C11.6444 2.71686 11.6076 2.52399 11.535 2.34401C11.4624 2.16403 11.3556 2.0005 11.2205 1.86288C11.0855 1.72527 10.9251 1.6163 10.7485 1.54228C10.5719 1.46826 10.3827 1.43066 10.1917 1.43166C10.0008 1.43266 9.81191 1.47223 9.63606 1.54809C9.46022 1.62394 9.30088 1.73458 9.16727 1.8736L9.04234 2.00091C8.98522 2.05914 8.95312 2.1381 8.95312 2.22044C8.95312 2.30277 8.98522 2.38174 9.04234 2.43997L10.6536 4.08258C10.6819 4.11149 10.7156 4.13444 10.7526 4.15009C10.7896 4.16574 10.8293 4.1738 10.8694 4.1738C10.9094 4.1738 10.9491 4.16574 10.9862 4.15009C11.0232 4.13444 11.0568 4.11149 11.0851 4.08258L11.2094 3.95527Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63795 2.63086L6.53125 3.15066",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3696 5.42383L9.89062 6.56589",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73768 4.31641L7.87109 5.19019",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91435 8.78899C8.91435 8.62429 8.85015 8.46633 8.73586 8.34986C8.62157 8.2334 8.46656 8.16797 8.30494 8.16797H5.25785C5.09623 8.16797 4.94122 8.2334 4.82693 8.34986C4.71264 8.46633 4.64844 8.62429 4.64844 8.78899V12.2046C4.64844 12.287 4.68054 12.366 4.73768 12.4242C4.79483 12.4824 4.87233 12.5151 4.95315 12.5151H8.60964C8.69046 12.5151 8.76796 12.4824 8.8251 12.4242C8.88225 12.366 8.91435 12.287 8.91435 12.2046V8.78899Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBath);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bath.83049ff65a29e9e1c2b441596ba1d20e.svg";